import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BulkUpdateService } from '../../../../../service/bulk-update.service';
import { BulkUpdateExecutionSummaryModel } from '../../../../../model/bulk-update-execution-summary.model';

@Component({
  selector: 'auto-bulk-update-execution',
  templateUrl: './bulk-update-execution.component.html',
  styleUrl: './bulk-update-execution.component.scss'
})
export class BulkUpdateExecutionComponent implements OnInit {
  executions: BulkUpdateExecutionSummaryModel[] = [];
  selectedExecution: BulkUpdateExecutionSummaryModel | null = null;

  filterText: string = '';

  totalExecutions: number = 0;
  notStartedCount: number = 0;
  inProgressCount: number = 0;
  succeededCount: number = 0;
  skippedCount: number = 0;
  failedCount: number = 0;

  loading = false;
  error: string | null = null;

  constructor(private bulkUpdateService: BulkUpdateService, private messageService: MessageService) {}

  ngOnInit(): void {
    this.loadExecutions();
  }

  loadExecutions(): void {
    this.loading = true;
    this.error = null;
    this.bulkUpdateService.getBulkUpdateExecutions().subscribe({
      next: (data) => {
        this.executions = Array.isArray(data) ? data : [];
        this.totalExecutions = this.executions.length;
        this.computeSummaryCounts();
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load executions' });
        this.error = null;
        this.executions = [];
        this.totalExecutions = 0;
        this.notStartedCount = 0;
        this.inProgressCount = 0;
        this.succeededCount = 0;
        this.skippedCount = 0;
        this.failedCount = 0;
        this.loading = false;
      }
    });
  }


  private computeSummaryCounts(): void {
    let notStarted = 0;
    let inProgress = 0;
    let succeeded = 0;
    let skipped = 0;
    let failed = 0;

    for (const row of this.executions) {
      // Sum the per-execution status values provided by the API
      notStarted += (row as any)?.notStarted ?? 0;
      inProgress += (row as any)?.inProgress ?? 0;
      succeeded += (row as any)?.succeeded ?? 0;
      skipped += (row as any)?.skipped ?? 0;
      failed += (row as any)?.failed ?? 0;
    }

    this.notStartedCount = notStarted;
    this.inProgressCount = inProgress;
    this.succeededCount = succeeded;
    this.skippedCount = skipped;
    this.failedCount = failed;
  }
}
